import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import AccountReporter from './Report';
export const accountReporterRoutes = [
  {'component': <AccountReporter />, 'path': paths.AccountState},
];
